import { NgModule } from '@angular/core';
import { PDPNavigatorService } from '~shared/modules/pdp-navigator/pdp-navigator.service';

@NgModule({
  providers: [PDPNavigatorService],
})
export class PDPNavigatorModule {}
